

import { CartaoCreditoType, Clientes, EtapaPagamentoObject, EtapasPagamento, FormasPagamento, PagamentoCartaoType, SituacoesPagamento, TipoPagamentoObject, TipoSituacaoPagamentoObject } from "./types";

export const LISTA_UF = [
    { text: "Acre", value: "AC" },
    { text: "Alagoas", value: "AL" },
    { text: "Amapá", value: "AP" },
    { text: "Amazonas", value: "AM" },
    { text: "Bahia", value: "BA" },
    { text: "Ceará", value: "CE" },
    { text: "Distrito Federal", value: "DF" },
    { text: "Espírito Santo", value: "ES" },
    { text: "Goiás", value: "GO" },
    { text: "Maranhão", value: "MA" },
    { text: "Mato Grosso", value: "MT" },
    { text: "Mato Grosso do Sul", value: "MS" },
    { text: "Minas Gerais", value: "MG" },
    { text: "Pará", value: "PA" },
    { text: "Paraíba", value: "PB" },
    { text: "Paraná", value: "PR" },
    { text: "Pernambuco", value: "PE" },
    { text: "Piauí", value: "PI" },
    { text: "Rio de Janeiro", value: "RJ" },
    { text: "Rio Grande do Norte", value: "RN" },
    { text: "Rio Grande do Sul", value: "RS" },
    { text: "Rondônia", value: "RO" },
    { text: "Roraima", value: "RR" },
    { text: "Santa Catarina", value: "SC" },
    { text: "São Paulo", value: "SP" },
    { text: "Sergipe", value: "SE" },
    { text: "Tocantins", value: "TO" },
];


export const MAXLENGTH_NOMES: number = 40;

export const BOLETO_ID: number = 1;
export const BOLETO: TipoPagamentoObject = {
    id: BOLETO_ID,
    nome: "Boleto",
    value: "boleto"
};

export const CARTAO_CREDITO_ID: number = 2;
export const CARTAO_CREDITO: TipoPagamentoObject = {
    id: CARTAO_CREDITO_ID,
    nome: "Cartão de Crédito",
    value: "cartao",
}

export const FINANCIAMENTO_ID: number = 3
export const FINANCIAMENTO: TipoPagamentoObject = {
    id: FINANCIAMENTO_ID,
    nome: "Financiamento Via Plataforma",
    value: "financiamento"
}

export const BOLETO_CARTAO_ID: number = 5;
export const BOLETO_CARTAO: TipoPagamentoObject = {
    id: BOLETO_CARTAO_ID,
    nome: "Boleto e Cartão de Crédito",
    value: "boleto_carta_credito"
}

export const BOLETO_FINANCIAMENTO_ID: number = 6;
export const BOLETO_FINANCIAMENTO: TipoPagamentoObject = {
    id: BOLETO_FINANCIAMENTO_ID,
    nome: "Boleto e Financiamento Via Plataforma",
    value: "boleto_financiamento",
}

export const CARTAO_FINANCIAMENTO_ID: number = 7;
export const CARTAO_FINANCIAMENTO: TipoPagamentoObject = {
    id: CARTAO_FINANCIAMENTO_ID,
    nome: "Cartão de Crédito e Financiamento Via Plataforma",
    value: "cartao_financiamento"
}

export const PIX_ID: number = 8;
export const PIX: TipoPagamentoObject = {
    id: PIX_ID,
    nome: "PIX",
    value: "pix"
}

export const PIX_CARTAO_CREDITO_ID: number = 9;
export const PIX_CARTAO: TipoPagamentoObject = {
    id: PIX_CARTAO_CREDITO_ID,
    nome: "PIX e Cartão de Crédito",
    value: "pix_cartao"
}

export const PIX_FINANCIAMENTO_ID: number = 12;
export const PIX_FINANCIAMENTO: TipoPagamentoObject = {
    id: PIX_FINANCIAMENTO_ID,
    nome: "PIX e Financiamento Via Plataforma",
    value: "pix_financiamento"
}

export const FINANCIMENTO_INDIRETO_ID: number = 4;
export const FINANCIMENTO_INDIRETO: TipoPagamentoObject = {
    id: FINANCIMENTO_INDIRETO_ID,
    nome: "Financiamento Externo",
    value: "carta_credito"
}

export const BOLETO_FINANCIAMENTO_INDIRETO_ID: number = 10;
export const BOLETO_FINANCIAMENTO_INDIRETO: TipoPagamentoObject = {
    id: BOLETO_FINANCIAMENTO_INDIRETO_ID,
    nome: "Boleto e Financiamento Externo",
    value: "boleto_carta_credito"
}

export const CARTAO_CREDITO_FINANCIAMENTO_INDIRETO_ID: number = 11;
export const CARTAO_CREDITO_FINANCIAMENTO_INDIRETO: TipoPagamentoObject = {
    id: CARTAO_CREDITO_FINANCIAMENTO_INDIRETO_ID,
    nome: "Cartão de Crédito e Financiamento Externo",
    value: "boleto_carta_credito"
}

export const PIX_FINANCIAMENTO_INDIRETO_ID: number = 13;
export const PIX_FINANCIAMENTO_INDIRETO: TipoPagamentoObject = {
    id: PIX_FINANCIAMENTO_INDIRETO_ID,
    nome: "PIX e Financiamento Externo",
    value: "pix_carta_credito"
}

export const FORMAS_PAGAMENTO: FormasPagamento = {
    [BOLETO_ID]: BOLETO,
    [CARTAO_CREDITO_ID]: CARTAO_CREDITO,
    [FINANCIAMENTO_ID]: FINANCIAMENTO,
    [BOLETO_CARTAO_ID]: BOLETO_CARTAO,
    [BOLETO_FINANCIAMENTO_ID]: BOLETO_FINANCIAMENTO,
    [CARTAO_FINANCIAMENTO_ID]: CARTAO_FINANCIAMENTO,
    [PIX_ID]: PIX,
    [PIX_CARTAO_CREDITO_ID]: PIX_CARTAO,
    [PIX_FINANCIAMENTO_ID]: PIX_FINANCIAMENTO,
    [FINANCIMENTO_INDIRETO_ID]: FINANCIMENTO_INDIRETO,
    [BOLETO_FINANCIAMENTO_INDIRETO_ID]: BOLETO_FINANCIAMENTO_INDIRETO,
    [CARTAO_CREDITO_FINANCIAMENTO_INDIRETO_ID]: CARTAO_CREDITO_FINANCIAMENTO_INDIRETO,
    [PIX_FINANCIAMENTO_INDIRETO_ID]: PIX_FINANCIAMENTO_INDIRETO,

}

export const tiposEnderecos = [
    {
        text: "Principal",
        value: "endereco_principal"
    },
    {
        text: "Entrega",
        value: "endereco_entrega"
    }
];

export const SITUACAO_PAGAMENTO_PENDENTE_ID = "pendente";
export const SITUACAO_PAGAMENTO_FINALIZADO_ID = "finalizado";
export const SITUACAO_PAGAMENTO_CANCELADO_ID = "cancelado";

export const SITUACAO_PAGAMENTO_PENDENTE: TipoSituacaoPagamentoObject = {
    id: SITUACAO_PAGAMENTO_PENDENTE_ID,
    nome: "Pendente",
    value: SITUACAO_PAGAMENTO_PENDENTE_ID
};

export const SITUACAO_PAGAMENTO_FINALIZADO: TipoSituacaoPagamentoObject = {
    id: SITUACAO_PAGAMENTO_FINALIZADO_ID,
    nome: "Pagamento Reconhecido",
    value: SITUACAO_PAGAMENTO_FINALIZADO_ID
};

export const SITUACAO_PAGAMENTO_CANCELADO: TipoSituacaoPagamentoObject = {
    id: SITUACAO_PAGAMENTO_CANCELADO_ID,
    nome: "Pagamento Cancelado",
    value: SITUACAO_PAGAMENTO_CANCELADO_ID
};

export const SITUACOES_PAGAMENTO: SituacoesPagamento = {
    [SITUACAO_PAGAMENTO_PENDENTE_ID]: SITUACAO_PAGAMENTO_PENDENTE,
    [SITUACAO_PAGAMENTO_FINALIZADO_ID]: SITUACAO_PAGAMENTO_FINALIZADO,
    [SITUACAO_PAGAMENTO_CANCELADO_ID]: SITUACAO_PAGAMENTO_CANCELADO,
}

const ETAPA_PAGAMENTO_DADOS_CLIENTE_ID = "dados_cliente";
const ETAPA_PAGAMENTO_FORMAS_PAGAMENTO_ID = "formas_pagamento";
const ETAPA_PAGAMENTO_NEGOCIACAO_ID = "negociacao";
const ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO_ID = "complemento_pagamento";
const ETAPA_PAGAMENTO_FATURAMENTO_ID = "faturamento";

export const ETAPA_PAGAMENTO_DADOS_CLIENTE: EtapaPagamentoObject = {
    id: ETAPA_PAGAMENTO_DADOS_CLIENTE_ID,
    nome: "Dados Cliente",
    value: ETAPA_PAGAMENTO_DADOS_CLIENTE_ID
};

export const ETAPA_PAGAMENTO_FORMAS_PAGAMENTO: EtapaPagamentoObject = {
    id: ETAPA_PAGAMENTO_FORMAS_PAGAMENTO_ID,
    nome: "Formas Pagamento",
    value: ETAPA_PAGAMENTO_FORMAS_PAGAMENTO_ID
};

export const ETAPA_PAGAMENTO_NEGOCIACAO: EtapaPagamentoObject = {
    id: ETAPA_PAGAMENTO_NEGOCIACAO_ID,
    nome: "Negociação",
    value: ETAPA_PAGAMENTO_NEGOCIACAO_ID
};

export const ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO: EtapaPagamentoObject = {
    id: ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO_ID,
    nome: "Complemento Pagamento",
    value: ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO_ID
};

export const ETAPA_PAGAMENTO_FATURAMENTO: EtapaPagamentoObject = {
    id: ETAPA_PAGAMENTO_FATURAMENTO_ID,
    nome: "Negociação (Comprovante Pagamento)",
    value: ETAPA_PAGAMENTO_FATURAMENTO_ID
};

export const ETAPAS_PAGAMENTO: EtapasPagamento = {
    [ETAPA_PAGAMENTO_DADOS_CLIENTE_ID]: ETAPA_PAGAMENTO_DADOS_CLIENTE,
    [ETAPA_PAGAMENTO_FORMAS_PAGAMENTO_ID]: ETAPA_PAGAMENTO_FORMAS_PAGAMENTO,
    [ETAPA_PAGAMENTO_NEGOCIACAO_ID]: ETAPA_PAGAMENTO_NEGOCIACAO,
    [ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO_ID]: ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO,
    [ETAPA_PAGAMENTO_FATURAMENTO_ID]: ETAPA_PAGAMENTO_FATURAMENTO,
}

export const tiposEtapaPagamento = [
    {
        text: "Dados Cliente",
        value: "dados_cliente"
    },
    {
        text: "Formas Pagamento",
        value: "formas_pagamento"
    },
    {
        text: "Negociação",
        value: "negociacao"
    },
    {
        text: "Complemento Pagamento",
        value: "complemento_pagamento"
    }
]

export const DEAFULT_CARTAO: CartaoCreditoType & PagamentoCartaoType = {
    cvc: '',
    expiry: '',
    focus: '',
    name: '',
    number: '',
    is_valid: false,
    parcelas: 1,
    valor_parcela: 0.0,
    valor_total: 0.0,
    valor_original: 0.0,
    issuer: "",
    parcela: null
};

export const SITUACAO_PAGAMENTO_CARTA_CREDITO_CARTA_PENDENTE_ID = "pendente";
export const SITUACAO_PAGAMENTO_CARTA_CREDITO_CARTA_APROVADO_ID = "aprovado";
export const SITUACAO_PAGAMENTO_CARTA_COMPROVANTE_PAGAMENTO_PENDENTE_ID = "pendente";

export const situacaoErro = {
    value: "erro",
    text: "Em análise - Intelbras"
}

export const situacaoCarta = [
    {
        value: "pendente",
        text: "Aguardando Envio"
    },
    {
        value: "preenchido",
        text: "Em análise - Financeira"
    },
    {
        value: "aprovado",
        text: "Aprovada"
    },
    situacaoErro,
];

export const situacaoComprovante = [
    {
        value: "pendente",
        text: "Aguardando Envio"
    },
    {
        value: "aprovado",
        text: "Aprovado"
    },
    {
        value: "preenchido",
        text: "Em análise - Financeira"
    },
    {
        value: "revisao",
        text: "Aguardando Reenvio"
    },
    {
        value: "nota_fiscal",
        text: "Aguardando NF"
    },
    situacaoErro,
];

export const situacaoProposta = [
    {
        value: "pendente",
        text: "Pendente Prenchimento"
    },
    {
        value: "preenchido",
        text: "Em Análise"
    },
    {
        value: "enviado",
        text: "Em análise - Financeira"
    },
    {
        value: "pre_aprovado",
        text: "Pré aprovado"
    },
    {
        value: "aprovado",
        text: "Análise Concluída"
    },
    {
        value: "revisao",
        text: "Pendente Revisão"
    },
    situacaoErro,
];

export const situacaoDocumento = [
    {
        value: "pendente",
        text: "Pendente de Uploads"
    },
    {
        value: "aprovado",
        text: "Analise Concluída"
    },
    {
        value: "preenchido",
        text: "Em Analise"
    },
    {
        value: "revisao",
        text: "Pendente Revisão"
    },
    {
        value: "enviado",
        text: "Em análise - Financeira"
    },
    situacaoErro,
];

export const situacaoPlano = [
    {
        value: "pendente",
        text: "Pendente de Confirmação"
    },
    {
        value: "aprovado",
        text: "Analise Concluída"
    },
    {
        value: "enviado",
        text: "Confirmação concluída"
    },
    situacaoErro,
];

export const situacaoAssinatura = [
    {
        value: "pendente",
        text: "Pendente de Confirmação"
    },
    {
        value: "solicitado",
        text: "Solicitação Enviada"
    },
    {
        value: "aprovado",
        text: "Assinatura Concluída"
    },
    {
        value: "enviado",
        text: "Em análise - Financeira"
    },
    situacaoErro,
];


export const DEFAULT_CLIENTE: Clientes = {
    contato_whatsapp: null,
    documento: null,
    email: null,
    enderecos: [],
    inscricao_estadual: null,
    fantasia: null,
    nome: null,
    telefone: null,
    tipo_contribuinte: "nao_contribuinte",
    tipo_pessoa: "fisica",
    usa_whatsapp: null,
    usuario_id: null,
}

export const PROJETOS_AVULSO_VALOR_MINIMO_ID = "PROJETOS_AVULSO_VALOR_MINIMO";
export const MENSAGEM_QUANTIDADE_CABOS_INVALIDA = "Qtd deve ser múltipla de 25";
export const ADMIN_MAX_VALUE = 9999999999;